export { default as ImageCaptionComponent } from "./ImageCaptionComponent";
export { default as ImageCaptionFactory } from "./ImageCaptionComponentFactory";
